export default __webpack_public_path__ + "static/media/Lets Play.0aede336.png";